export const PAGE_NAME = 'recommendations_list_page';

export const T_PREFIX = 'recommendations_list_perseus';
